import { FC } from 'react'
import { Anchor, ButtonLink, ButtonStyled } from './styled-components'
import { TProps } from './types'

const ButtonComponent: FC<TProps> = (props) => {
  const { href, to, target, size = 'large' } = props
  if (href) {
    return (
      <Anchor href={href} target={target}>
        <ButtonStyled {...props} size={size} />
      </Anchor>
    )
  }
  if (to) {
    return (
      <ButtonLink to={to}>
        <ButtonStyled {...props} size={size} />
      </ButtonLink>
    )
  }
  return <ButtonStyled {...props} size={size} />
}

export default ButtonComponent
